const api = [
  {
    id: 1,
    title: "Modern Chair",
    price: 109.95,
    description:
      "Lorem ipsum dolor sit amet, consectetur adipiscing elit. Sed do eiusmod tempor incididunt ut labore et dolore magna aliqua. Ut enim ad minim veniam, quis nostrud exercitation ullamco laboris nisi ut aliquip ex ea commodo consequat. Duis aute irure dolor in reprehenderit in voluptate velit esse cillum dolore eu fugiat nulla pariatur.",
    category: "chair",
    image: "assets/images/chair1.jpg",
    isInCart: false,
    rate: 3.9,
    count: 120,
  },
  {
    id: 2,
    title: "Classic Chair",
    price: 22.3,
    description:
      "Lorem ipsum dolor sit amet, consectetur adipiscing elit. Sed do eiusmod tempor incididunt ut labore et dolore magna aliqua. Ut enim ad minim veniam, quis nostrud exercitation ullamco laboris nisi ut aliquip ex ea commodo consequat. Duis aute irure dolor in reprehenderit in voluptate velit esse cillum dolore eu fugiat nulla pariatur.",
    category: "chair",
    image: "assets/images/chair2.jpg",
    isIncart: false,
    rate: 4.1,
    count: 259,
  },
  {
    id: 3,
    title: "Stylish Dining Chair",
    price: 55.99,
    description:
      "Lorem ipsum dolor sit amet, consectetur adipiscing elit. Sed do eiusmod tempor incididunt ut labore et dolore magna aliqua. Ut enim ad minim veniam, quis nostrud exercitation ullamco laboris nisi ut aliquip ex ea commodo consequat. Duis aute irure dolor in reprehenderit in voluptate velit esse cillum dolore eu fugiat nulla pariatur.",
    category: "chair",
    image: "assets/images/chair3.jpg",
    isIncart: false,
    rate: 4.7,
    count: 500,
  },
  {
    id: 4,
    title: "Contemporary Lounge Chair",
    price: 15.99,
    description:
      "Lorem ipsum dolor sit amet, consectetur adipiscing elit. Sed do eiusmod tempor incididunt ut labore et dolore magna aliqua. Ut enim ad minim veniam, quis nostrud exercitation ullamco laboris nisi ut aliquip ex ea commodo consequat. Duis aute irure dolor in reprehenderit in voluptate velit esse cillum dolore eu fugiat nulla pariatur.",
    category: "chair",
    image: "assets/images/chair4.jpg",
    isIncart: false,
    rate: 2.1,
    count: 430,
  },
  {
    id: 5,
    title: "Classic Wooden Bookshelf",
    price: 695,
    description:
      "Lorem ipsum dolor sit amet, consectetur adipiscing elit. Sed do eiusmod tempor incididunt ut labore et dolore magna aliqua. Ut enim ad minim veniam, quis nostrud exercitation ullamco laboris nisi ut aliquip ex ea commodo consequat. Duis aute irure dolor in reprehenderit in voluptate velit esse cillum dolore eu fugiat nulla pariatur.",
    category: "table",
    image: "assets/images/table1.jpg",
    isIncart: false,
    rate: 4.6,
    count: 400,
  },
  {
    id: 6,
    title: "Versatile Folding Table ",
    price: 168,
    description:
      "Lorem ipsum dolor sit amet, consectetur adipiscing elit. Sed do eiusmod tempor incididunt ut labore et dolore magna aliqua. Ut enim ad minim veniam, quis nostrud exercitation ullamco laboris nisi ut aliquip ex ea commodo consequat. Duis aute irure dolor in reprehenderit in voluptate velit esse cillum dolore eu fugiat nulla pariatur.",
    category: "table",
    image: "assets/images/table2.jpg",
    isIncart: false,
    rate: 3.9,
    count: 70,
  },
  {
    id: 7,
    title: "Classic Dining Table",
    price: 9.99,
    description:
      "Lorem ipsum dolor sit amet, consectetur adipiscing elit. Sed do eiusmod tempor incididunt ut labore et dolore magna aliqua. Ut enim ad minim veniam, quis nostrud exercitation ullamco laboris nisi ut aliquip ex ea commodo consequat. Duis aute irure dolor in reprehenderit in voluptate velit esse cillum dolore eu fugiat nulla pariatur.",
    category: "table",
    image: "assets/images/table3.jpg",
    isIncart: false,
    rate: 3,
    count: 400,
  },
  {
    id: 8,
    title: "Contemporary Table",
    price: 10.99,
    description:
      "Lorem ipsum dolor sit amet, consectetur adipiscing elit. Sed do eiusmod tempor incididunt ut labore et dolore magna aliqua. Ut enim ad minim veniam, quis nostrud exercitation ullamco laboris nisi ut aliquip ex ea commodo consequat. Duis aute irure dolor in reprehenderit in voluptate velit esse cillum dolore eu fugiat nulla pariatur.",
    category: "table",
    image: "assets/images/table4.jpg",
    isIncart: false,
    rate: 1.9,
    count: 100,
  },
  {
    id: 9,
    title: "Versatile Folding Table",
    price: 64,
    description:
      "Lorem ipsum dolor sit amet, consectetur adipiscing elit. Sed do eiusmod tempor incididunt ut labore et dolore magna aliqua. Ut enim ad minim veniam, quis nostrud exercitation ullamco laboris nisi ut aliquip ex ea commodo consequat. Duis aute irure dolor in reprehenderit in voluptate velit esse cillum dolore eu fugiat nulla pariatur.",
    category: "table",
    image: "assets/images/pexel1.jpg",
    isIncart: false,
    rate: 3.3,
    count: 203,
  },
  {
    id: 10,
    title: "Luxurious King Size Bed",
    price: 109,
    description:
      "Lorem ipsum dolor sit amet, consectetur adipiscing elit. Sed do eiusmod tempor incididunt ut labore et dolore magna aliqua. Ut enim ad minim veniam, quis nostrud exercitation ullamco laboris nisi ut aliquip ex ea commodo consequat. Duis aute irure dolor in reprehenderit in voluptate velit esse cillum dolore eu fugiat nulla pariatur.",
    category: "bed",
    image: "assets/images/pexel2.jpg",
    isIncart: false,
    rate: 2.9,
    count: 470,
  },
  {
    id: 11,
    title: "Retro Vintage Chair",
    price: 109,
    description:
      "Lorem ipsum dolor sit amet, consectetur adipiscing elit. Sed do eiusmod tempor incididunt ut labore et dolore magna aliqua. Ut enim ad minim veniam, quis nostrud exercitation ullamco laboris nisi ut aliquip ex ea commodo consequat. Duis aute irure dolor in reprehenderit in voluptate velit esse cillum dolore eu fugiat nulla pariatur.",
    category: "chair",
    image: "assets/images/pexels3.jpg",
    isIncart: false,
    rate: 4.8,
    count: 319,
  },

  {
    id: 12,
    title: "Elegant Wooden Platform Bed",
    price: 114,
    description:
      "Lorem ipsum dolor sit amet, consectetur adipiscing elit. Sed do eiusmod tempor incididunt ut labore et dolore magna aliqua. Ut enim ad minim veniam, quis nostrud exercitation ullamco laboris nisi ut aliquip ex ea commodo consequat. Duis aute irure dolor in reprehenderit in voluptate velit esse cillum dolore eu fugiat nulla pariatur.",
    category: "bed",
    image: "assets/images/trending-item-06.jpg",
    isIncart: false,
    rate: 4.8,
    count: 400,
  },
  {
    id: 13,
    title: "Contemporary Bed",
    price: 599,
    description:
      "Lorem ipsum dolor sit amet, consectetur adipiscing elit. Sed do eiusmod tempor incididunt ut labore et dolore magna aliqua. Ut enim ad minim veniam, quis nostrud exercitation ullamco laboris nisi ut aliquip ex ea commodo consequat. Duis aute irure dolor in reprehenderit in voluptate velit esse cillum dolore eu fugiat nulla pariatur.",
    category: "bed",
    image: "assets/images/trending-item-07.jpg",
    isIncart: false,
    rate: 2.9,
    count: 250,
  },
  {
    id: 14,
    title: "Cozy Queen Bed Frame ",
    price: 999.99,
    description:
      "Lorem ipsum dolor sit amet, consectetur adipiscing elit. Sed do eiusmod tempor incididunt ut labore et dolore magna aliqua. Ut enim ad minim veniam, quis nostrud exercitation ullamco laboris nisi ut aliquip ex ea commodo consequat. Duis aute irure dolor in reprehenderit in voluptate velit esse cillum dolore eu fugiat nulla pariatur.",
    category: "bed",
    image: "assets/images/trending-item-08.jpg",
    isIncart: false,
    rate: 2.2,
    count: 140,
  },
  {
    id: 15,
    title: "Rustic Farmhouse Bed",
    price: 56.99,
    description:
      "Lorem ipsum dolor sit amet, consectetur adipiscing elit. Sed do eiusmod tempor incididunt ut labore et dolore magna aliqua. Ut enim ad minim veniam, quis nostrud exercitation ullamco laboris nisi ut aliquip ex ea commodo consequat. Duis aute irure dolor in reprehenderit in voluptate velit esse cillum dolore eu fugiat nulla pariatur.",
    category: "bed",
    image: "assets/images/pexels4.jpg",
    isIncart: false,
    rate: 2.6,
    count: 235,
  },
  {
    id: 16,
    title: "Chic Contemporary Sofa",
    price: 29.95,
    description:
      "Lorem ipsum dolor sit amet, consectetur adipiscing elit. Sed do eiusmod tempor incididunt ut labore et dolore magna aliqua. Ut enim ad minim veniam, quis nostrud exercitation ullamco laboris nisi ut aliquip ex ea commodo consequat. Duis aute irure dolor in reprehenderit in voluptate velit esse cillum dolore eu fugiat nulla pariatur.",
    category: "sofa",
    image: "assets/images/sofa1.jpg",
    isIncart: false,
    rate: 2.9,
    count: 340,
  },
  {
    id: 17,
    title: "Luxurious Velvet Sofa",
    price: 39.99,
    description:
      "Lorem ipsum dolor sit amet, consectetur adipiscing elit. Sed do eiusmod tempor incididunt ut labore et dolore magna aliqua. Ut enim ad minim veniam, quis nostrud exercitation ullamco laboris nisi ut aliquip ex ea commodo consequat. Duis aute irure dolor in reprehenderit in voluptate velit esse cillum dolore eu fugiat nulla pariatur.",
    category: "sofa",
    image: "assets/images/sofa2.jpg",
    isIncart: false,
    rate: 3.8,
    count: 679,
  },
  {
    id: 18,
    title: "Modern Sectional Sofa",
    price: 9.85,
    description:
      "Lorem ipsum dolor sit amet, consectetur adipiscing elit. Sed do eiusmod tempor incididunt ut labore et dolore magna aliqua. Ut enim ad minim veniam, quis nostrud exercitation ullamco laboris nisi ut aliquip ex ea commodo consequat. Duis aute irure dolor in reprehenderit in voluptate velit esse cillum dolore eu fugiat nulla pariatur.",
    category: "sofa",
    image: "assets/images/sofa3.jpg",
    isIncart: false,
    rate: 4.7,
    count: 130,
  },
  {
    id: 19,
    title: "Classic Leather Sofa",
    price: 7.95,
    description:
      "Lorem ipsum dolor sit amet, consectetur adipiscing elit. Sed do eiusmod tempor incididunt ut labore et dolore magna aliqua. Ut enim ad minim veniam, quis nostrud exercitation ullamco laboris nisi ut aliquip ex ea commodo consequat. Duis aute irure dolor in reprehenderit in voluptate velit esse cillum dolore eu fugiat nulla pariatur.",
    category: "sofa",
    image: "assets/images/sofa4.jpg",
    isIncart: false,
    rate: 4.5,
    count: 146,
  },
  {
    id: 20,
    title: "Comfortable Sleeper Sofa",
    price: 12.99,
    description:
      "Lorem ipsum dolor sit amet, consectetur adipiscing elit. Sed do eiusmod tempor incididunt ut labore et dolore magna aliqua. Ut enim ad minim veniam, quis nostrud exercitation ullamco laboris nisi ut aliquip ex ea commodo consequat. Duis aute irure dolor in reprehenderit in voluptate velit esse cillum dolore eu fugiat nulla pariatur.",
    category: "sofa",
    image: "assets/images/pexels6.jpg",
    isIncart: false,
    rate: 3.6,
    count: 145,
  },
  {
    id: 21,
    title: "Ergonomic Task Chair",
    price: 66.99,
    description:
      "Lorem ipsum dolor sit amet, consectetur adipiscing elit. Sed do eiusmod tempor incididunt ut labore et dolore magna aliqua. Ut enim ad minim veniam, quis nostrud exercitation ullamco laboris nisi ut aliquip ex ea commodo consequat. Duis aute irure dolor in reprehenderit in voluptate velit esse cillum dolore eu fugiat nulla pariatur.",
    category: "chair",
    image: "assets/images/pexels7.jpg",
    isIncart: false,
    rate: 3.0,
    count: 145,
  },
  {
    id: 22,
    title: "Stylish L-Shaped Sofa",
    price: 19.99,
    description:
      "Lorem ipsum dolor sit amet, consectetur adipiscing elit. Sed do eiusmod tempor incididunt ut labore et dolore magna aliqua. Ut enim ad minim veniam, quis nostrud exercitation ullamco laboris nisi ut aliquip ex ea commodo consequat. Duis aute irure dolor in reprehenderit in voluptate velit esse cillum dolore eu fugiat nulla pariatur.",
    category: "sofa",
    image: "assets/images/sofa5.jpg",
    isIncart: false,
    rate: 3.6,
    count: 145,
  },
  {
    id: 23,
    title: "Minimalist Fabric Sofa",
    price: 12.99,
    description:
      "Lorem ipsum dolor sit amet, consectetur adipiscing elit. Sed do eiusmod tempor incididunt ut labore et dolore magna aliqua. Ut enim ad minim veniam, quis nostrud exercitation ullamco laboris nisi ut aliquip ex ea commodo consequat. Duis aute irure dolor in reprehenderit in voluptate velit esse cillum dolore eu fugiat nulla pariatur.",
    category: "sofa",
    image: "assets/images/sofa6.jpg",
    isIncart: false,
    rate: 3.6,
    count: 145,
  },
  {
    id: 24,
    title: "Luxury Marble Dining Table",
    price: 12.99,
    description:
      "Lorem ipsum dolor sit amet, consectetur adipiscing elit. Sed do eiusmod tempor incididunt ut labore et dolore magna aliqua. Ut enim ad minim veniam, quis nostrud exercitation ullamco laboris nisi ut aliquip ex ea commodo consequat. Duis aute irure dolor in reprehenderit in voluptate velit esse cillum dolore eu fugiat nulla pariatur.",
    category: "table",
    image: "assets/images/pexels8.jpg",
    isIncart: false,
    rate: 3.6,
    count: 145,
  },
  {
    id: 25,
    title: "Contemporary Table",
    price: 109.95,
    description:
      "Lorem ipsum dolor sit amet, consectetur adipiscing elit. Sed do eiusmod tempor incididunt ut labore et dolore magna aliqua. Ut enim ad minim veniam, quis nostrud exercitation ullamco laboris nisi ut aliquip ex ea commodo consequat. Duis aute irure dolor in reprehenderit in voluptate velit esse cillum dolore eu fugiat nulla pariatur.",
    category: "table",
    image: "assets/images/table5.jpg",
    isIncart: false,
    rate: 3.9,
    count: 120,
  },
  {
    id: 26,
    title: "Elegant Marble Side Table",
    price: 109.95,
    description:
      "Lorem ipsum dolor sit amet, consectetur adipiscing elit. Sed do eiusmod tempor incididunt ut labore et dolore magna aliqua. Ut enim ad minim veniam, quis nostrud exercitation ullamco laboris nisi ut aliquip ex ea commodo consequat. Duis aute irure dolor in reprehenderit in voluptate velit esse cillum dolore eu fugiat nulla pariatur.",
    category: "table",
    image: "assets/images/table6.jpg",
    isIncart: false,
    rate: 3.9,
    count: 120,
  },
  {
    id: 27,
    title: "Stylish Rectangular Table",
    price: 109.95,
    description:
      "Lorem ipsum dolor sit amet, consectetur adipiscing elit. Sed do eiusmod tempor incididunt ut labore et dolore magna aliqua. Ut enim ad minim veniam, quis nostrud exercitation ullamco laboris nisi ut aliquip ex ea commodo consequat. Duis aute irure dolor in reprehenderit in voluptate velit esse cillum dolore eu fugiat nulla pariatur.",
    category: "table",
    image: "assets/images/table7.jpg",
    isIncart: false,
    rate: 3.9,
    count: 120,
  },
  {
    id: 28,
    title: "Platform Bed",
    price: 109.95,
    description:
      "Lorem ipsum dolor sit amet, consectetur adipiscing elit. Sed do eiusmod tempor incididunt ut labore et dolore magna aliqua. Ut enim ad minim veniam, quis nostrud exercitation ullamco laboris nisi ut aliquip ex ea commodo consequat. Duis aute irure dolor in reprehenderit in voluptate velit esse cillum dolore eu fugiat nulla pariatur.",
    category: "bed",
    image: "assets/images/bed1.jpg",
    isIncart: false,
    rate: 3.9,
    count: 120,
  },
  {
    id: 29,
    title: "Luxurious Leather Bed",
    price: 12.99,
    description:
      "Lorem ipsum dolor sit amet, consectetur adipiscing elit. Sed do eiusmod tempor incididunt ut labore et dolore magna aliqua. Ut enim ad minim veniam, quis nostrud exercitation ullamco laboris nisi ut aliquip ex ea commodo consequat. Duis aute irure dolor in reprehenderit in voluptate velit esse cillum dolore eu fugiat nulla pariatur.",
    category: "bed",
    image: "assets/images/bed2.jpg",
    isIncart: false,
    rate: 4.6,
    count: 145,
  },
  {
    id: 30,
    title: "Modern Bed with Drawers",
    price: 32.99,
    description:
      "Lorem ipsum dolor sit amet, consectetur adipiscing elit. Sed do eiusmod tempor incididunt ut labore et dolore magna aliqua. Ut enim ad minim veniam, quis nostrud exercitation ullamco laboris nisi ut aliquip ex ea commodo consequat. Duis aute irure dolor in reprehenderit in voluptate velit esse cillum dolore eu fugiat nulla pariatur.",
    category: "bed",
    image: "assets/images/bed3.jpg",
    isIncart: false,
    rate: 3.9,
    count: 145,
  },
  {
    id: 31,
    title: "Contemporary Accent Chair",
    price: 72.99,
    description:
      "Lorem ipsum dolor sit amet, consectetur adipiscing elit. Sed do eiusmod tempor incididunt ut labore et dolore magna aliqua. Ut enim ad minim veniam, quis nostrud exercitation ullamco laboris nisi ut aliquip ex ea commodo consequat. Duis aute irure dolor in reprehenderit in voluptate velit esse cillum dolore eu fugiat nulla pariatur.",
    category: "chair",
    image: "assets/images/chair5.jpg",
    isIncart: false,
    rate: 3.6,
    count: 145,
  },
  {
    id: 32,
    title: "Rustic Cottage Sofa",
    price: 19.99,
    description:
      "Lorem ipsum dolor sit amet, consectetur adipiscing elit. Sed do eiusmod tempor incididunt ut labore et dolore magna aliqua. Ut enim ad minim veniam, quis nostrud exercitation ullamco laboris nisi ut aliquip ex ea commodo consequat. Duis aute irure dolor in reprehenderit in voluptate velit esse cillum dolore eu fugiat nulla pariatur.",
    category: "sofa",
    image: "assets/images/sofa7.jpg",
    isIncart: false,
    rate: 3.2,
    count: 145,
  },
  {
    id: 5,
    title: "Classic Wooden Bookshelf",
    price: 695,
    description:
      "Lorem ipsum dolor sit amet, consectetur adipiscing elit. Sed do eiusmod tempor incididunt ut labore et dolore magna aliqua. Ut enim ad minim veniam, quis nostrud exercitation ullamco laboris nisi ut aliquip ex ea commodo consequat. Duis aute irure dolor in reprehenderit in voluptate velit esse cillum dolore eu fugiat nulla pariatur.",
    category: "table",
    image: "assets/images/pexels9.jpg",
    isIncart: false,
    rate: 4.6,
    count: 400,
  },
];

export default api;
